(function () {
  var DURATION = 1600;
  var COUNT_SELECTOR = '.iw-counter__number[data-count], .iw-expect__stat-value[data-count]';

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function countDecimals(numStr) {
    var parts = String(numStr).split('.');
    return parts.length > 1 ? parts[1].length : 0;
  }

  function formatNumber(value, useComma, decimals) {
    var output;
    if (decimals > 0) {
      output = value.toFixed(decimals);
    } else {
      output = String(Math.round(value));
    }

    if (!useComma) return output;

    var pieces = output.split('.');
    pieces[0] = Number(pieces[0]).toLocaleString('en-US');
    return pieces.join('.');
  }

  function parseTarget(raw) {
    var text = (raw || '').trim();
    if (!text) return null;

    var slashMatch = text.match(/^(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)$/);
    if (slashMatch) {
      return {
        type: 'fraction',
        value: parseFloat(slashMatch[1].replace(',', '')),
        denominator: slashMatch[2],
        useComma: slashMatch[1].indexOf(',') !== -1,
        decimals: countDecimals(slashMatch[1].replace(',', '')),
      };
    }

    var match = text.match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)([^0-9]*)$/);
    if (!match) return null;

    var numberPart = match[2];
    return {
      type: 'number',
      prefix: match[1] || '',
      value: parseFloat(numberPart.replace(/,/g, '')),
      suffix: match[3] || '',
      useComma: numberPart.indexOf(',') !== -1,
      decimals: countDecimals(numberPart.replace(/,/g, '')),
    };
  }

  function renderValue(parsed, current) {
    if (parsed.type === 'fraction') {
      return formatNumber(current, parsed.useComma, parsed.decimals) + '/' + parsed.denominator;
    }
    return parsed.prefix + formatNumber(current, parsed.useComma, parsed.decimals) + parsed.suffix;
  }

  function animateNumber(el) {
    if (!el || el.dataset.counted === 'true') return;

    var targetText = el.dataset.count || el.textContent;
    var parsed = parseTarget(targetText);
    if (!parsed || !Number.isFinite(parsed.value)) return;

    el.dataset.counted = 'true';
    el.textContent = renderValue(parsed, 0);

    var start = null;

    function frame(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / DURATION, 1);
      var current = parsed.value * easeOutCubic(progress);
      el.textContent = renderValue(parsed, current);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = targetText;
      }
    }

    requestAnimationFrame(frame);
  }

  function observeCounters(root) {
    var numbers = (root || document).querySelectorAll(COUNT_SELECTOR);
    if (!numbers.length) return;

    if (!('IntersectionObserver' in window)) {
      numbers.forEach(animateNumber);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateNumber(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    numbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  function updateCounterHeight(section) {
    var scope = section || document;
    var inners = scope.querySelectorAll('.iw-counter__inner');

    inners.forEach(function (inner) {
      var wrapper = inner.closest('.iw-counter');
      if (!wrapper) return;
      wrapper.style.setProperty('--iw-counter-height', inner.offsetHeight + 'px');
    });
  }

  function initSection(section) {
    var root = section || document;
    observeCounters(root);
    updateCounterHeight(root);

    root.querySelectorAll('.iw-counter__inner').forEach(function (inner) {
      if (inner.dataset.resizeBound === 'true' || typeof ResizeObserver === 'undefined') return;
      inner.dataset.resizeBound = 'true';
      new ResizeObserver(function () {
        updateCounterHeight(inner.closest('.iw-counter') || document);
      }).observe(inner);
    });
  }

  function initAll() {
    initSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    updateCounterHeight(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
